import type { TranslationKey } from '@core/i18n/translations/en';
import type {
  NotificationActionName,
  NotificationActionType,
  NotificationMessage,
  NotificationStatus,
} from './notifications.models';

/** React `notificationTextMap`. */
export const NOTIFICATION_TEXT: Readonly<Record<NotificationMessage, TranslationKey>> = {
  workspace_invitation_title: 'notifications.companyInvitation.title',
  workspace_invitation_message: 'notifications.companyInvitation.message',
  removed_from_workspace_title: 'notifications.removedFromCompany.title',
  removed_from_workspace_message: 'notifications.removedFromCompany.message',
  notification_invoice_created_title: 'notifications.newInvoice.title',
  notification_invoice_created_message: 'notifications.newInvoice.message',
  fixed_payments_cycle_expiring_title: 'notifications.fixedCycleTerminates.title',
  fixed_payments_cycle_expiring_message: 'notifications.fixedCycleTerminates.message',
  employee_sent_draft_cycle_title: 'notifications.employeeSentDraftCycle.title',
  employee_sent_draft_cycle_message: 'notifications.employeeSentDraftCycle.message',
  employer_approved_draft_cycle_title: 'notifications.employerApprovedDraftCycle.title',
  employer_approved_draft_cycle_message: 'notifications.employerApprovedDraftCycle.message',
  employer_rejected_draft_cycle_title: 'notifications.employerRejectedDraftCycle.title',
  employer_rejected_draft_cycle_message: 'notifications.employerRejectedDraftCycle.message',
  employer_created_cycle_title: 'notifications.employerCreatedCycle.title',
  employer_created_cycle_message: 'notifications.employerCreatedCycle.message',
  employer_shared_cycle_framework_title: 'notifications.employerSharedCycleFramework.title',
  employer_shared_cycle_framework_message: 'notifications.employerSharedCycleFramework.message',
  employee_requested_cycle_cancel_title: 'notifications.employeeRequestedCycleCancel.title',
  employee_requested_cycle_cancel_message: 'notifications.employeeRequestedCycleCancel.message',
  employer_canceled_cycle_title: 'notifications.employerCanceledCycle.title',
  employer_canceled_cycle_message: 'notifications.employerCanceledCycle.message',
  employer_dismissed_cycle_cancel_request_title:
    'notifications.employerDismissedCancelRequest.title',
  employer_dismissed_cycle_cancel_request_message:
    'notifications.employerDismissedCancelRequest.message',
  update_national_id_title: 'notifications.updateNationalId.title',
  update_national_id_message: 'notifications.updateNationalId.message',
  bailiff_termination_title: 'notifications.bailiffTermination.title',
  bailiff_termination_message: 'notifications.bailiffTermination.message',
};

/** React `notificationStatusMap`. */
export const NOTIFICATION_STATUS: Readonly<
  Record<
    NotificationStatus,
    { readonly badgeColor: 'green' | 'gray'; readonly text: TranslationKey }
  >
> = {
  new: { badgeColor: 'green', text: 'notifications.status.new' },
  read: { badgeColor: 'gray', text: 'notifications.status.read' },
};

/** React `buttonVariantMap`. */
export const ACTION_BUTTON_VARIANT: Readonly<
  Record<NotificationActionType, 'primary' | 'secondary'>
> = {
  default: 'primary',
  destructive: 'primary',
  cancel: 'secondary',
};

/** React `actionNameMap`. */
export const ACTION_NAME: Readonly<Record<NotificationActionName, TranslationKey>> = {
  accept: 'notifications.action.accept',
  decline: 'notifications.action.decline',
  reject: 'notifications.action.reject',
  fill: 'notifications.action.fill',
  ok: 'notifications.action.ok',
};
